import React from "react";

function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

function isFunction(fn) {
  return typeof fn === "function";
}

function getModule(obj) {
  return obj && obj.__esModule ? obj.default || obj : obj;
}

function isReactComponent(com, name, saName) {
  if (
    com &&
    com.prototype &&
    (com.prototype instanceof React.Component ||
      com.prototype.isReactComponent) &&
    // isFunction(com.prototype.render) &&
    // name !== "Radio" &&
    // saName !== "Radio.Button" &&
    // saName !== "Tree.TreeNode" &&
    // saName !== "Menu.ItemGroup" &&
    saName !== "Select.Option" &&
    saName !== "Select.OptGroup" &&
    saName !== "SelectNew.Option" &&
    saName !== "SelectNew.OptGroup" &&
    // .type === class强比较，搞事情的代码暂时先不加
    name !== "WeaDebugRouteMenu"
    // route 会判定多个子节点...
  ) {
    return true;
  } else if (name === "Col" || name === "Icon" || name === "Card") {
    // no isReactComponent Col Icon Card
    return true;
  }
  return false;
}

export default function middleware(obj, name, saName) {
  const com = getModule(obj);
  let result = com;
  if (isObject(window.pcComponentsConfig)) {
    const overwrite = window.pcComponentsConfig[name];
    if (isObject(overwrite)) {
      if (isReactComponent(com, name)) {
        result = React.forwardRef((props, ref) => {
          if (props._noOverwrite) {
            return React.createElement(com, { ...props, ref });
          }
          let newProps = { ...props };
          const overwriteInRender = window.pcComponentsConfig[name];
          if (isObject(overwriteInRender)) {
            // overwrite render lev 1
            const renderFn = overwriteInRender.overwriteRenderFn;
            if (isFunction(renderFn)) {
              const overwriteRender = renderFn(newProps, saName || name);
              if (overwriteRender !== false) {
                return overwriteRender;
              }
            }
            // overwrite props lev 2
            const propsJson = overwriteInRender.overwritePropsJson;
            if (isObject(propsJson)) {
              newProps = { ...newProps, ...propsJson };
            }
            const propsFn = overwriteInRender.overwritePropsFn;
            if (isFunction(propsFn)) {
              const overwriteProps = propsFn(newProps, saName || name);
              if (isObject(overwriteProps)) {
                newProps = { ...newProps, ...overwriteProps };
              }
            }
            // overwrite class lev 3
            const classFn = overwriteInRender.overwriteClassFn;
            if (isFunction(classFn)) {
              const overwriteClass = classFn(com, newProps, saName || name);
              if (overwriteClass.com && isObject(overwriteClass.props)) {
                return React.createElement(overwriteClass.com, {
                  ...overwriteClass.props,
                  ref
                });
              }
            }
          }
          return React.createElement(com, { ...newProps, ref });
        });
      }
      Object.keys(com).forEach(key => {
        const staticAttribute = getModule(com[key]);
        const staticAttributeName = `${name}.${key}`;
        if (isReactComponent(staticAttribute, key, staticAttributeName)) {
          result[key] = middleware(staticAttribute, key, staticAttributeName);
        } else {
          result[key] = staticAttribute;
        }
      });
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./middleware.js